import React, {useEffect, useState, useRef} from 'react'
import {
    Button,
    Box,
    Drawer,
    DrawerOverlay,
    DrawerContent,
    DrawerHeader,
    Image,
    DrawerBody,
    Heading,
    Divider,
    DrawerFooter,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {useLocation} from 'react-router-dom'
import {getUrl} from '../../../../../utils/cloudinary-utils'
import {getItemBadge} from '../../../../../utils/product-utils'
import PropTypes from 'prop-types'
import ProductViewCompact from '../../../../product-view-compact'
import {
    useCustomerId,
    useShopperCustomersMutation,
    useShopperBasketsMutationHelper
} from '@salesforce/commerce-sdk-react'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import useEinstein from '@salesforce/retail-react-app/app/hooks/use-einstein'
import CloudinaryImage from '../../../../cloudinary-media/image'
import Video from '../../hero/partials/video'
import {useWishList} from '../../../../../hooks/use-wish-list'
import LoadingSpinner from '../../../../loading-spinner'
import useTagManager from '../../../../../hooks/use-tag-manager'
import logger from '@salesforce/retail-react-app/app/utils/logger-instance'
import {logBasketErrorToSsr} from '../../../../../utils/log-basket-error-to-ssr'
import {useGlobaleContext} from '../../../../../contexts/globale'
import {useAddToCartDrawerContext} from '../../../../../hooks/use-add-to-cart-drawer'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import useMonetate from '../../../../../hooks/use-monetate'
import {useSiteContext} from '../../../../../contexts/site'
import {onClient} from '@salesforce/commerce-sdk-react/utils'
import {CookieStorage} from '@salesforce/commerce-sdk-react/auth/storage'

const COOKIE_ID = 'gwp_promotion'

const ShopThisLookModal = ({
    desktopImage,
    imageAlt,
    desktopVideo,
    mobileVideo,
    desktopVideoThumbnail,
    mobileVideoThumbnail,
    videoAlt,
    videoEnableSound,
    videoDisableAutoPlay,
    cloudinaryAspectRatio,
    products,
    modalDisclosure,
    analyticsProps = {}
}) => {
    const shouldDisplayVideo = desktopVideo || mobileVideo
    const {isYR} = useSiteContext()
    const {isOpen, onClose: close} = modalDisclosure
    const tagManager = useTagManager()
    const location = useLocation()

    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const onClose = () => {
        // Cancel all component states
        close()
        setChildProductSelection({})
        setShowAddedCta(false)
        setShowAddToCartLoader(false)
    }
    const modalBodyRef = useRef(null)
    const drawerBodyRef = useRef(null)

    const isProductASet = true
    const {isLoading: isBasketLoading, data: basket} = useCurrentBasket()
    const [childProductSelection, setChildProductSelection] = useState({})
    const isAllOutOfStock =
        Object.values(childProductSelection).every((p) => p?.variant?.orderable === false) &&
        Object.keys(childProductSelection)?.length === products?.data?.length
    const childProductRefs = React.useRef({})
    const einstein = useEinstein()
    const [showAddToCartLoader, setShowAddToCartLoader] = useState(false)
    const {countryISO, globaleCurrency} = useGlobaleContext()
    const {setOpenBonusModal} = useSiteContext()
    const [showAddedCta, setShowAddedCta] = useState(false)
    const customerId = useCustomerId()
    const monetate = useMonetate()
    const {data: wishlist} = useWishList()
    const {data: customer} = useCurrentCustomer()
    const [updatedProducts, setUpdatedProducts] = useState(products?.data)
    const {onOpen: onAddToCartDrawerOpen, onClose: onAddToCartDrawerClose} =
        useAddToCartDrawerContext()

    useEffect(() => {
        onAddToCartDrawerClose()
    }, [location?.pathname])

    useEffect(() => {
        const selectedVariantProducts = products?.data?.map((p) => ({
            ...p,
            variationValues:
                p?.variationValues ||
                (p?.variants?.length === 1 && p?.variants?.[0]?.variationValues) ||
                {}
        }))
        setUpdatedProducts(selectedVariantProducts)
    }, [products?.data?.length])
    const handleAddToCart = async (productSelectionValues, isSet, index) => {
        try {
            const productItems = productSelectionValues.map(({variant, quantity}) => {
                const parentProduct = updatedProducts?.find((p) =>
                    p?.variants?.some((v) => v.productId === variant.productId)
                )
                return {
                    productId: variant.productId,
                    price: variant.price,
                    quantity,
                    c_analyticsAttributes: JSON.stringify({
                        listID: 'Shop The Look',
                        listName: 'Shop The Look',
                        itemBadge: getItemBadge(parentProduct || variant, {
                            selectedVariant: variant
                        })
                    })
                }
            })
            setShowAddToCartLoader(isSet)
            const filteredItems = productItems?.filter((i) =>
                updatedProducts?.some((p) =>
                    p.variants.some((v) => v.productId === i.productId && v.orderable)
                )
            )
            const basketResponse = await addItemToNewOrExistingBasket(filteredItems)

            var addedItems = updatedProducts.map((item, index) => ({
                product: {...item, index: index + 1}
            }))

            if (isSet) {
                tagManager.addToCart(
                    updatedProducts,
                    null,
                    filteredItems,
                    null,
                    'shopTheLook',
                    null,
                    false,
                    {},
                    false,
                    false,
                    false,
                    analyticsProps
                )
                const method = 'Shop The Look'

                const addToCartData = {
                    itemsAdded: addedItems,
                    method: method,
                    currency: globaleCurrency,
                    sorting: undefined,
                    listName: method,
                    listId: method
                }
                tagManager.addToCartGA4(addToCartData)
            } else {
                const trackingData = {
                    ...analyticsProps,
                    id: filteredItems?.[0]?.productId
                }
                tagManager.addToCart(
                    [updatedProducts[index]],
                    null,
                    filteredItems,
                    null,
                    'shopTheLook',
                    null,
                    false,
                    {},
                    false,
                    false,
                    false,
                    trackingData
                )
                onClose()
            }
            setShowAddedCta(isSet)
            setShowAddToCartLoader(false)
            setTimeout(() => {
                setShowAddedCta(false)
                if (isSet) {
                    onClose()
                }
            }, 1000)
            einstein.sendAddToCart(filteredItems)

            // If the items were successfully added, set the return value to be used
            // by the Add to Bag modal.
            return {productSelectionValues: productSelectionValues, basketResponse: basketResponse}
        } catch (error) {
            setShowAddToCartLoader(false)
            const errResponse = error?.response ? await error.response.json() : null
            console.log('error', error.message)
            logger.error('ATCXL Error adding product to basket', {
                namespace: 'ShopTheLook.handleAddToCart',
                additionalProperties: {error, errResponse, basketId: basket?.basketId}
            })
            logBasketErrorToSsr('ShopTheLook.handleAddToCart', {
                error,
                errResponse,
                basketId: basket?.basketId
            })
        }
    }
    const handleProductSetAddToCart = async () => {
        // Get all the selected products, and pass them to the addToCart handler which
        // accepts an array.
        const productSelectionValues = Object.values(childProductSelection)
        const notSelectedProducts = updatedProducts.filter(
            (product) =>
                !productSelectionValues.some(
                    (selectedProduct) => selectedProduct.product.id === product.id
                )
        )

        // Validate the orderability of the selected products
        if (notSelectedProducts.length > 0) {
            const id = notSelectedProducts[0].id
            const ref = childProductRefs.current[id]?.ref

            if (ref) {
                notSelectedProducts.forEach((notSelectedProduct) => {
                    childProductRefs.current[notSelectedProduct.id]?.validateOrderability()
                })

                if (isMobile) {
                    drawerBodyRef?.current.scrollTo({
                        top: ref.offsetTop - 100,
                        behavior: 'smooth'
                    })
                } else {
                    modalBodyRef?.current.scrollTo({
                        top: ref.offsetTop - 100,
                        behavior: 'smooth'
                    })
                }
            }
        } else {
            const response = await handleAddToCart(productSelectionValues, true)
            const {productSelectionValues: itemsAdded, basketResponse} = response || {}
            if (itemsAdded?.length) {
                const promoId = (
                    basketResponse?.bonusDiscountLineItems?.find((i) =>
                        /gwp/i?.test(i.promotionId)
                    ) || basketResponse?.bonusDiscountLineItems?.[0]
                )?.promotionId // We'll give priority of thw GWP promotions as per the requirement.
                const cookie =
                    onClient() &&
                    new CookieStorage({
                        keySuffix: '',
                        sharedContext: !onClient()
                    })
                const gwpPromotionState = onClient() && cookie ? cookie.get(COOKIE_ID) : null

                const firstProduct = updatedProducts[0]
                if (!(promoId && gwpPromotionState !== 'closed')) {
                    onAddToCartDrawerOpen({
                        product:
                            itemsAdded?.find((i) => i?.product?.id === firstProduct?.id)?.product ||
                            firstProduct,
                        itemsAdded,
                        selectedQuantity: 1
                    })
                }
                setOpenBonusModal(true)
                monetate.monetateTrackPage(
                    'addToBagModal',
                    window.mtBreadcrumb,
                    basketResponse?.productItems,
                    customer?.customerType === 'registered',
                    wishlist?.customerProductListItems?.length || 0,
                    null,
                    null,
                    productSelectionValues,
                    basketResponse?.giftCertificateItems
                )
            }
            return itemsAdded
        }
    }
    const isMobile = useBreakpointValue({base: true, md: false})
    const [wishlistLoading, setWishlistLoading] = useState([])
    const [wishlistSpinner, setWishlistSpinner] = useState(false)

    useEffect(() => {
        // Note: Please remove this once we move KS to PWA
        const resetStateOnBack = (event) => {
            if (event.persisted) {
                // Page was restored from bfcache (back-forward cache)
                setWishlistSpinner(false)
                setWishlistLoading(false)
            }
        }
        window.addEventListener('pageshow', resetStateOnBack)
        return () => {
            window.removeEventListener('pageshow', resetStateOnBack)
        }
    }, [])
    const [wishlistAnimation, setWishlistAnimation] = useState(false)
    const createCustomerProductListItem = useShopperCustomersMutation(
        'createCustomerProductListItem'
    )
    const deleteCustomerProductListItem = useShopperCustomersMutation(
        'deleteCustomerProductListItem'
    )

    // Polling function to make sure customerId & listId are available
    const customerIdRef = useRef(null)
    const listIdRef = useRef(null)

    useEffect(() => {
        if (customerIdRef) {
            customerIdRef.current = customerId
        }
    }, [customerId])
    useEffect(() => {
        if (listIdRef) {
            listIdRef.current = wishlist?.id || null
        }
    }, [wishlist])

    const waitForRefs = async () => {
        const maxRetries = 10
        const interval = 100
        let retries = 0

        return new Promise((resolve, reject) => {
            const checkRefs = () => {
                const listId = listIdRef.current
                if (customerIdRef.current === customerId && listId) {
                    resolve()
                } else if (retries < maxRetries) {
                    retries++
                    setTimeout(checkRefs, interval)
                } else {
                    reject(new Error('Timeout waiting for customerId and listId'))
                }
            }
            checkRefs()
        })
    }

    const addItemToWishlist = async (index, selectedProductId) => {
        setWishlistLoading([...wishlistLoading, selectedProductId])
        setWishlistSpinner(true)
        await waitForRefs()
        //        monetate.setUsedWishlist()
        // TODO: This wishlist object is from an old API, we need to replace it with the new one.
        const listId = wishlist?.id

        try {
            await createCustomerProductListItem.mutate(
                {
                    parameters: {customerId, listId},
                    body: {
                        quantity: 1,
                        public: true,
                        priority: 1,
                        type: 'product',
                        productId: selectedProductId
                    }
                },
                {
                    onSuccess: () => {
                        setWishlistAnimation(index)
                        setWishlistSpinner(false)
                        setTimeout(() => {
                            setWishlistAnimation(index)
                        }, 1000)
                    },
                    onSettled: () => {
                        setWishlistSpinner(false)
                        setWishlistLoading(wishlistLoading.filter((id) => id !== selectedProductId))
                    }
                }
            )
        } catch (error) {
            setWishlistSpinner(false)
            logger.error('Error adding product to wishlist', {
                namespace: 'ShopTheLook.handleAddToWishlist',
                additionalProperties: {error, productId: selectedProductId}
            })
        }
    }

    const removeItemFromWishlist = async (index, selectedProductId) => {
        setWishlistLoading([...wishlistLoading, selectedProductId])
        setWishlistSpinner(true)
        await waitForRefs()

        const listId = wishlist?.id
        const itemId = wishlist.customerProductListItems.find(
            (i) => i.productId === selectedProductId
        )?.id

        try {
            await deleteCustomerProductListItem.mutate(
                {
                    body: {},
                    parameters: {customerId, listId, itemId}
                },
                {
                    onError: () => {
                        setWishlistSpinner(false)
                        setWishlistAnimation(false)
                    },
                    onSuccess: () => {
                        setWishlistSpinner(false)
                        setWishlistAnimation(false)
                    },
                    onSettled: () => {
                        setWishlistSpinner(false)
                        setWishlistLoading(wishlistLoading.filter((id) => id !== selectedProductId))
                    }
                }
            )
        } catch (error) {
            setWishlistSpinner(false)
            logger.error('Error adding product to wishlist', {
                namespace: 'ShopTheLook.removeItemFromWishlist',
                additionalProperties: {error, productId: selectedProductId}
            })
        }
    }

    return (
        <Box>
            {!isMobile && (
                <Modal isOpen={isOpen} onClose={onClose} returnFocusOnClose={false}>
                    <ModalOverlay background="blackAlpha600" height="100%" />
                    <ModalContent borderRadius="20px" maxWidth="fit-content" margin="auto">
                        <ModalBody
                            padding={0}
                            className="modal-filters"
                            display="inline-flex"
                            height="661px"
                            maxHeight="calc(100vh - 100px)"
                        >
                            {(wishlistSpinner || showAddToCartLoader) && (
                                <LoadingSpinner position="fixed" top="auto" />
                            )}
                            <Box
                                position="absolute"
                                top="10px"
                                right="10px"
                                _hover={{
                                    backgroundColor: 'gray.100'
                                }}
                                cursor="pointer"
                                borderRadius="50%"
                                padding="15px"
                                transition="all, 0.3s ease"
                                onClick={onClose}
                            >
                                <Image
                                    width="15px"
                                    height="15px"
                                    alt="Cross Icon"
                                    src={getUrl('UIImages/images/crossed-icon.svg')}
                                />
                            </Box>
                            <Box
                                className="left-section"
                                width="504px"
                                height="661px"
                                maxHeight="calc(100vh - 100px)"
                                overflow="hidden"
                                borderRadius="20px 0 0 20px"
                            >
                                {shouldDisplayVideo ? (
                                    <Video
                                        desktopVideo={desktopVideo || mobileVideo}
                                        mobileVideo={mobileVideo || desktopVideo}
                                        desktopVideoThumbnail={desktopVideoThumbnail}
                                        mobileVideoThumbnail={mobileVideoThumbnail}
                                        videoDisableAutoPlay={videoDisableAutoPlay}
                                        videoEnableSound={videoEnableSound}
                                        videoAlt={videoAlt}
                                        cloudinaryAspectRatio={cloudinaryAspectRatio}
                                    />
                                ) : (
                                    <CloudinaryImage
                                        src={desktopImage}
                                        aspectRatio="504:661"
                                        styles={{
                                            display: {base: 'none', md: 'block'},
                                            width: '504px',
                                            height: '661px',
                                            maxHeight: 'calc(100vh - 100px)',
                                            borderRadius: '20px 0 0 20px',
                                            htmlWidth: 504,
                                            htmlHeight: 661,
                                            objectFit: 'cover'
                                        }}
                                        imgSizes={{lg: '50vw', md: '50vw', base: '100vw'}}
                                        sizes={[1024, 1280, 1440, 1920]}
                                        alt={imageAlt}
                                    />
                                )}
                            </Box>
                            <Box
                                className="right-section"
                                maxWidth="415px"
                                sx={{
                                    '& .product-name': {
                                        fontFamily: 'heading',
                                        fontSize: '18px',
                                        fontWeight: '400',
                                        letterSpacing: '0.09px'
                                    },
                                    '& .product-view-stack': {
                                        gap: '5px'
                                    },
                                    '& .product-view-stack b': {
                                        fontFamily: 'body',
                                        fontSize: '14px',
                                        letterSpacing: '0.07px',
                                        lineHeight: '22px'
                                    }
                                }}
                            >
                                <Box
                                    boxShadow="none"
                                    margin="20px 20px 15px 20px"
                                    padding="0 !important"
                                >
                                    <Heading
                                        as="h2"
                                        color="black.100"
                                        fontSize="25px"
                                        fontWeight="500"
                                        letterSpacing="0.125px"
                                        fontFamily="caslon"
                                    >
                                        <FormattedMessage
                                            defaultMessage="Shop The Look"
                                            id="shop.the.look"
                                        />
                                    </Heading>
                                    <Divider
                                        color="gray.500"
                                        margin="10px 0 0 0"
                                        border="1px solid"
                                        display="block"
                                    />
                                </Box>
                                <Box
                                    ref={modalBodyRef}
                                    className="products-list"
                                    height="498px"
                                    maxHeight="calc(100vh - 263px)"
                                    overflow="auto"
                                    margin="0 20px"
                                    position="relative"
                                    sx={{
                                        overflowX: 'auto',
                                        '&::-webkit-scrollbar': {
                                            width: '2px'
                                        },
                                        '&::-webkit-scrollbar-thumb': {
                                            backgroundColor: 'gray.800',
                                            borderRadius: '2px',
                                            display: 'block'
                                        },
                                        '&::-webkit-scrollbar-track': {
                                            backgroundColor: 'gray.400',
                                            borderRadius: '2px',
                                            display: 'block'
                                        },
                                        userSelect: 'none',
                                        scrollBehavior: 'smooth'
                                    }}
                                >
                                    {
                                        // Render the child products
                                        updatedProducts?.map((product, index) => (
                                            <Box
                                                key={`${product.id || product.productId}-${index}`}
                                                data-testid="child-product"
                                                sx={{
                                                    '& .wishlist-wrapper': {
                                                        display:
                                                            countryISO === 'US' || countryISO === ''
                                                                ? 'block'
                                                                : 'none'
                                                    }
                                                }}
                                            >
                                                <ProductViewCompact
                                                    // Do not use an arrow function as we are manipulating the functions scope.
                                                    ref={function (ref) {
                                                        // Assign the "set" scope of the ref, this is how we access the internal
                                                        // validation.
                                                        childProductRefs.current[product.id] = {
                                                            ref,
                                                            validateOrderability:
                                                                this.validateOrderability
                                                        }
                                                    }}
                                                    product={product}
                                                    isProductPartOfSet={true}
                                                    childOfBundleQuantity={1}
                                                    enableFavourite={true}
                                                    wishlistAnimation={wishlistAnimation}
                                                    wishlist={wishlist}
                                                    onFavouriteToggle={(
                                                        toBeFavourite,
                                                        selectedProductId
                                                    ) => {
                                                        const action = toBeFavourite
                                                            ? addItemToWishlist
                                                            : removeItemFromWishlist
                                                        return action(index, selectedProductId)
                                                    }}
                                                    index={index}
                                                    isShopTheLook={true}
                                                    addToCart={
                                                        isProductASet
                                                            ? (variant, quantity) =>
                                                                  handleAddToCart(
                                                                      [
                                                                          {
                                                                              product: product,
                                                                              variant,
                                                                              quantity: quantity
                                                                          }
                                                                      ],
                                                                      false,
                                                                      index
                                                                  )
                                                            : null
                                                    }
                                                    onVariantSelected={(
                                                        product,
                                                        variant,
                                                        quantity
                                                    ) => {
                                                        if (quantity) {
                                                            setChildProductSelection(
                                                                (previousState) => ({
                                                                    ...previousState,
                                                                    [product.id]: {
                                                                        product,
                                                                        variant,
                                                                        quantity: quantity
                                                                    }
                                                                })
                                                            )
                                                        } else {
                                                            const selections = {
                                                                ...childProductSelection
                                                            }
                                                            delete selections[product.id]
                                                            setChildProductSelection(selections)
                                                        }
                                                    }}
                                                    isProductLoading={false}
                                                    isBasketLoading={isBasketLoading}
                                                    onTileClick={onClose}
                                                />
                                            </Box>
                                        ))
                                    }
                                </Box>
                                <Box
                                    height="86px"
                                    backgroundColor="white"
                                    alignContent="center"
                                    borderRadius="0 0 20px 0"
                                >
                                    <Box
                                        className="button-wrapper"
                                        borderColor="gray.500 !important"
                                        textAlign="center"
                                        borderTop="1px solid"
                                        height="inherit"
                                        alignContent="center"
                                        margin="0 20px"
                                    >
                                        <Button
                                            width="374px"
                                            cursor={isAllOutOfStock ? 'not-allowed' : 'pointer'}
                                            brand={isYR ? 'yr' : 'ks'}
                                            backgroundColor={
                                                isAllOutOfStock
                                                    ? 'gray.40'
                                                    : isYR
                                                    ? 'black.100'
                                                    : 'teal.500'
                                            }
                                            height="56px"
                                            borderRadius="90px"
                                            border={isAllOutOfStock ? 'none' : '1px solid'}
                                            color={isAllOutOfStock ? 'gray.650' : 'white'}
                                            transition="all, 0.3s ease"
                                            onClick={() => {
                                                if (!isAllOutOfStock) {
                                                    handleProductSetAddToCart()
                                                }
                                            }}
                                            fontSize="17px"
                                            aria-label={
                                                isAllOutOfStock ? 'Sold Out' : 'Add All to Bag'
                                            }
                                            _hover={{
                                                backgroundColor: isAllOutOfStock
                                                    ? 'gray.425'
                                                    : isYR
                                                    ? 'black.50'
                                                    : 'teal.400'
                                            }}
                                        >
                                            {showAddedCta ? (
                                                <FormattedMessage
                                                    defaultMessage="Added"
                                                    id="product_view.button.added_to_cart"
                                                />
                                            ) : isAllOutOfStock ? (
                                                <FormattedMessage
                                                    id="shop_the_look.sold_out"
                                                    defaultMessage="Sold Out"
                                                />
                                            ) : (
                                                <FormattedMessage
                                                    id="add.all.to.bag"
                                                    defaultMessage="Add All to Bag"
                                                />
                                            )}
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                        </ModalBody>
                    </ModalContent>
                </Modal>
            )}

            {isMobile && (
                <Drawer
                    placement="bottom"
                    isOpen={isOpen}
                    onClose={onClose}
                    size="sm"
                    motionPreset="slideInBottom"
                    scrollBehavior="inside"
                    isFullHeight={false}
                    // Add the following 1 line to fix the Safari behavior of Drawer Close
                    returnFocusOnClose={false}
                >
                    <DrawerOverlay background="blackAlpha600" height="100%" />
                    <DrawerContent
                        // {...styles.quickAdd.drawerContent}
                        height="70vh"
                        borderRadius="20px 20px 0 0 !important"
                        maxHeight="70vh"
                    >
                        <DrawerHeader
                            boxShadow="none"
                            margin={{base: '20px 20px 0px 20px', lg: '20px 20px 11px 20px'}}
                            padding="0 !important"
                        >
                            <Heading
                                color="black.100"
                                fontSize="25px"
                                fontWeight="500"
                                letterSpacing="0.125px"
                                fontFamily="caslon"
                            >
                                <FormattedMessage
                                    defaultMessage="Shop The Look"
                                    id="shop.the.look"
                                />
                            </Heading>
                            <Divider
                                color="gray.500"
                                margin="20px 0"
                                border="1px solid"
                                display="block"
                            />
                        </DrawerHeader>
                        <Box
                            position="absolute"
                            top="10px"
                            right="10px"
                            _hover={{
                                backgroundColor: 'gray.100'
                            }}
                            cursor="pointer"
                            borderRadius="50%"
                            padding="15px"
                            transition="all, 0.3s ease"
                            onClick={onClose}
                        >
                            <Image
                                width="15px"
                                height="15px"
                                alt="Cross Icon"
                                src={getUrl('UIImages/images/crossed-icon.svg')}
                            />
                        </Box>
                        <DrawerBody
                            ref={drawerBodyRef}
                            padding={0}
                            className="shop-the-look-drawer"
                            display="grid"
                            gap="20px"
                            margin="0px 20px 0px 20px"
                            sx={{
                                '& .product-name': {
                                    fontFamily: 'heading',
                                    fontSize: '18px',
                                    fontWeight: '400',
                                    letterSpacing: '0.09px'
                                },
                                '& .product-view-stack': {
                                    gap: '5px'
                                },
                                '& .product-view-stack b': {
                                    fontFamily: 'body',
                                    fontSize: '14px',
                                    letterSpacing: '0.07px',
                                    lineHeight: '22px'
                                },
                                overflowX: 'auto',
                                whiteSpace: 'nowrap',
                                '&::-webkit-scrollbar': {
                                    width: '2px'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: 'gray.800',
                                    borderRadius: '2px',
                                    display: 'block'
                                },
                                '&::-webkit-scrollbar-track': {
                                    backgroundColor: 'gray.400',
                                    borderRadius: '2px',
                                    display: 'block'
                                },
                                userSelect: 'none',
                                scrollBehavior: 'smooth'
                            }}
                        >
                            {(wishlistSpinner || showAddToCartLoader) && (
                                <LoadingSpinner position="fixed" top="auto" />
                            )}
                            {
                                // Render the child products
                                updatedProducts?.map((product, index) => (
                                    <Box
                                        key={`${product.id || product.productId}-${index}`}
                                        data-testid="child-product"
                                        sx={{
                                            '& .wishlist-wrapper': {
                                                display:
                                                    countryISO === 'US' || countryISO === ''
                                                        ? 'block'
                                                        : 'none'
                                            }
                                        }}
                                    >
                                        <ProductViewCompact
                                            // Do not use an arrow function as we are manipulating the functions scope.
                                            ref={function (ref) {
                                                // Assign the "set" scope of the ref, this is how we access the internal
                                                // validation.
                                                childProductRefs.current[product.id] = {
                                                    ref,
                                                    validateOrderability: this.validateOrderability
                                                }
                                            }}
                                            product={product}
                                            isProductPartOfSet={true}
                                            childOfBundleQuantity={1}
                                            isShopTheLook={true}
                                            enableFavourite={true}
                                            wishlistAnimation={wishlistAnimation}
                                            wishlist={wishlist}
                                            onFavouriteToggle={(
                                                toBeFavourite,
                                                selectedProductId
                                            ) => {
                                                const action = toBeFavourite
                                                    ? addItemToWishlist
                                                    : removeItemFromWishlist
                                                return action(index, selectedProductId)
                                            }}
                                            index={index}
                                            addToCart={
                                                isProductASet
                                                    ? (variant, quantity) =>
                                                          handleAddToCart(
                                                              [
                                                                  {
                                                                      product: product,
                                                                      variant,
                                                                      quantity: quantity
                                                                  }
                                                              ],
                                                              false,
                                                              index
                                                          )
                                                    : null
                                            }
                                            onVariantSelected={(product, variant, quantity) => {
                                                if (quantity) {
                                                    setChildProductSelection((previousState) => ({
                                                        ...previousState,
                                                        [product.id]: {
                                                            product,
                                                            variant,
                                                            quantity: quantity
                                                        }
                                                    }))
                                                } else {
                                                    const selections = {...childProductSelection}
                                                    delete selections[product.id]
                                                    setChildProductSelection(selections)
                                                }
                                            }}
                                            isProductLoading={false}
                                            isBasketLoading={isBasketLoading}
                                        />
                                    </Box>
                                ))
                            }
                        </DrawerBody>
                        <DrawerFooter padding="20px">
                            <Button
                                width="full"
                                borderRadius="90px"
                                onClick={() => {
                                    if (!isAllOutOfStock) {
                                        handleProductSetAddToCart()
                                    }
                                }}
                                isDisabled={isAllOutOfStock}
                                fontSize="17px"
                                aria-label={isAllOutOfStock ? 'Sold Out' : 'Add All to Bag'}
                                height="56px"
                                cursor={isAllOutOfStock ? 'not-allowed' : 'pointer'}
                                brand={isYR ? 'yr' : 'ks'}
                                backgroundColor={
                                    isAllOutOfStock ? 'gray.40' : isYR ? 'black.100' : 'teal.500'
                                }
                                border={isAllOutOfStock ? 'none' : '1px solid'}
                                color={isAllOutOfStock ? 'gray.650' : 'white'}
                                _hover={{
                                    backgroundColor: isAllOutOfStock
                                        ? 'gray.425'
                                        : isYR
                                        ? 'black.50'
                                        : 'teal.400'
                                }}
                            >
                                {showAddedCta ? (
                                    <FormattedMessage
                                        defaultMessage="Added"
                                        id="product_view.button.added_to_cart"
                                    />
                                ) : isAllOutOfStock ? (
                                    <FormattedMessage
                                        id="shop_the_look.sold_out"
                                        defaultMessage="Sold Out"
                                    />
                                ) : (
                                    <FormattedMessage
                                        id="add.all.to.bag"
                                        defaultMessage="Add All to Bag"
                                    />
                                )}
                            </Button>
                        </DrawerFooter>
                    </DrawerContent>
                </Drawer>
            )}
        </Box>
    )
}

ShopThisLookModal.propTypes = {
    products: PropTypes.any,
    desktopImage: PropTypes.string,
    imageAlt: PropTypes.string,
    desktopVideo: PropTypes.string,
    mobileVideo: PropTypes.string,
    desktopVideoThumbnail: PropTypes.string,
    mobileVideoThumbnail: PropTypes.string,
    videoAlt: PropTypes.string,
    videoEnableSound: PropTypes.bool,
    videoDisableAutoPlay: PropTypes.bool,
    cloudinaryAspectRatio: PropTypes.string,
    modalDisclosure: PropTypes.shape({
        isOpen: PropTypes.bool,
        onClose: PropTypes.func
    }),
    analyticsProps: PropTypes.object
}

export default ShopThisLookModal
